export default __webpack_public_path__ + "static/media/SEC1550.34I-38847_-22821_0.ecd2c7b8.jpg";